import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';
import { AlertTriangle } from 'lucide-react';

// Warns full admins when partner coupon codes are nearly exhausted so they can
// re-bill partners before the codes run dry. Renders nothing when all is well.
export const LowCouponAlert = ({ linkToCoupons = true }) => {
  const { isFullAdmin } = useAuth();
  const [lowCoupons, setLowCoupons] = useState([]);

  useEffect(() => {
    if (!isFullAdmin) return;
    api.get('/admin/coupons/low-remaining')
      .then((res) => setLowCoupons(res.data.coupons || []))
      .catch(() => {});
  }, [isFullAdmin]);

  if (!isFullAdmin || lowCoupons.length === 0) return null;

  return (
    <div
      className="mb-4 rounded-[12px] border border-amber-300 bg-amber-50 p-4"
      data-testid="low-coupon-alert"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-4 w-4 text-amber-600 mt-0.5 shrink-0" />
        <div className="min-w-0">
          <p className="text-sm font-medium text-amber-900">
            {lowCoupons.length} coupon{lowCoupons.length !== 1 ? 's' : ''} running low on uses
          </p>
          <p className="text-xs text-amber-800 mt-1 leading-relaxed" data-testid="low-coupon-list">
            {lowCoupons.map((c, i) => (
              <span key={c.id}>
                {i > 0 && ' · '}
                <strong>{c.code}</strong> ({c.remaining} of {c.usage_limit} left)
              </span>
            ))}
          </p>
          {linkToCoupons && (
            <Link
              to="/team/coupons"
              className="inline-block mt-2 text-xs font-medium text-amber-900 underline hover:text-amber-700"
              data-testid="low-coupon-manage-link"
            >
              Manage coupons →
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
